import { Injectable } from '@angular/core';
import { Observable, fromEvent } from 'rxjs';
import { map, shareReplay, debounceTime } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ResizeService {
  public onResize$: Observable<Window>;

  constructor() {
    // Use RxJS to listen to window resize events
    // 1. fromEvent: create an observable from the event
    // 2. debounceTime(100): debounce to avoid many emissions during resizing (performance)
    // 3. map: convert Event to Window (keeps the same return shape as previous code)
    // 4. shareReplay(1): ensure multiple subscribers share the same listener
    this.onResize$ = fromEvent(window, 'resize').pipe(
      debounceTime(100),
      map((event) => event.target as Window),
      shareReplay(1)
    );
  }
}
